import { Location } from '@trnsact/trnsact-shared-types';
import { createTableColumns } from './tableConfig';
import { Table } from 'components/shared/Table';

interface Props {
  tableData?: Location[];
}

export const LocationsTable = ({ tableData }: Props) => {
  const columns = createTableColumns();

  return (
    <Table<Location>
      tableData={tableData || []}
      columns={columns}
      paginationOptions={{
        pageSize: 5,
      }}
    />
  );
};
